<template>
  <div>
    <div v-if="row.item.documents" :class="{ 'attachments-wrapper': (checkHtml(row.item.documents.slice()) > 0) }">
      <div class="mb-4 no-documents" v-if="row.item.documents.length === 0">Нет документов</div>
      <div v-else v-for="document in row.item.documents"
           :style="{ width: (row.item.documents.length > 0) ? '' : '100%' }"
           @click="openDocument(document, row.item.documents)"
           :key="document.id">
        <div v-if="document.html.length > 0" class="attachment" :style="{ width: attachmentWidth + 'px', position: 'relative' }">
          <div class="attachment-inner-container">
            <div class="file-icon-wrapper">
              <font-awesome-icon v-if="document.documentName && document.documentName.indexOf('с решением') !== -1" icon="file-signature" class="text-success"/>
              <font-awesome-icon v-else icon="file-alt"/>
            </div>
            <div class="attachment-name-wrapper">
              <div class="mr-4" v-html="document.documentName"></div>
            </div>
          </div>
        </div>
        <div v-if="checkHtml(row.item.documents.slice()) === 0" class="mb-4 no-documents">Нет документов</div>
      </div>
    </div>
    <div v-else class="text-center text-secondary my-2">
      <b-spinner class="align-middle mr-2"></b-spinner>
      <strong>Загрузка...</strong>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DocumentCard",
    props: ['row', 'attachmentWidth'],
    methods: {
      checkHtml (documents) {
        const hasHtml = documents.filter(document => document.html.length > 0)
        return hasHtml.length
      },
      openDocument (document, documents) {
        if (this.checkHtml(documents.slice()) > 0) {
          this.$emit('onOpenDocument', document)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .attachments-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    .attachment {
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 15px 10px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
      position: relative;
      min-height: 80px;
      height: calc(100% - 15px);
      background-color: #ffffff;
      &:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
        cursor: pointer;
        background-color: #ffffff;
      }
      .attachment-inner-container {
        display: flex;
        width: 100%;
        .file-icon-wrapper {
          margin-right: 10px;
          svg {
            font-size: 32px;
            color: #78909C;
          }
        }
        .attachment-name-wrapper {
          font-size: 14px;
          letter-spacing: 0.25px;
          line-height: 20px;
          color: #37474F;
        }
      }
    }
  }

  .no-documents {
    width: 100%;
    text-align: center;
  }
</style>
